/* eslint-disable */
// eslint-disable-next-line

import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
import VueProgressBar from 'vue-progressbar'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css'
import '../node_modules/@fortawesome/fontawesome-free/js/solid'
import '../node_modules/@fortawesome/fontawesome-free/css/brands.css'
import '../node_modules/font-awesome/scss/font-awesome.scss'
import AnimateCss from 'animate.css'
import VueCarousel from 'vue-carousel'
import { i18n } from './plugins/i18n'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.config.productionTip = false

// router.beforeEach((to, from, next) => {
  
//   let language = to.params.lang
//   if (!language) {
//     language = 'th'
//   }

//   i18n.locale = language
//   next()
// })

const options = {
  color: '#005BEA',
  failedColor: '#d64141',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueSweetalert2)
Vue.use(VuePlyr)
Vue.use(VueCarousel)
Vue.use(AnimateCss)
Vue.use(VueProgressBar, options)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
